var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-auto pa-3",staticStyle:{"min-width":"600px"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }